import { render, staticRenderFns } from "./CreditoInmobiliaria.vue?vue&type=template&id=b9708000&lang=html&"
import script from "./CreditoInmobiliaria.vue?vue&type=script&lang=js&"
export * from "./CreditoInmobiliaria.vue?vue&type=script&lang=js&"
import style0 from "./CreditoInmobiliaria.vue?vue&type=style&index=0&id=b9708000&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports